import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-md border border-secondary-200 bg-white py-1"
}

import BaseDropdown from '@/components/base/BaseDropdown.vue'
import BaseActionMenuButton from '@/components/base/menus/BaseActionMenuButton.vue'
import { createRandomUuid } from '@/helpers/functions'
import { useI18n } from 'vue-i18n'

interface Props {
  /** Array of action menu items */
  actions: ActionMenuItem[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseActionMenu',
  props: {
    actions: {}
  },
  setup(__props: any) {



const { t } = useI18n()

const id = createRandomUuid()

return (_ctx: any,_cache: any) => {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createBlock(BaseDropdown, { id: _unref(id) }, {
    button: _withCtx(({ toggle, open }) => [
      _createVNode(_component_IconButton, {
        class: "action-menu-toggler",
        "aria-label": 
          open ? _unref(t)('general.hide_all_actions') : _unref(t)('general.show_all_actions')
        ,
        icon: open ? '$close' : '$dots-vertical',
        onClick: _withModifiers(toggle, ["stop"])
      }, null, 8, ["aria-label", "icon", "onClick"])
    ]),
    default: _withCtx(() => [
      (__props.actions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
              return (_openBlock(), _createBlock(BaseActionMenuButton, {
                key: index,
                icon: action.icon,
                label: action.label,
                onClick: _withModifiers(($event: any) => (_ctx.$emit(action.event.replace(/_/g, '-'), action.params)), ["stop"])
              }, null, 8, ["icon", "label", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})